import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import Integration from "@/model/interface/Integration";
import { useUpdateIntegrationSyncSettingsMutation } from "@/store/rest_api";
import toast from "react-hot-toast";

interface Props {
  integration: Integration;
}

export default function IntegrationSyncToggle({ integration }: Props) {
  const [updateSyncSettings, { isLoading }] = useUpdateIntegrationSyncSettingsMutation();
  const enabled = integration.syncEnabled !== false;

  const toggleSync = async (value: boolean) => {
    try {
      await updateSyncSettings({ id: integration.id, syncEnabled: value }).unwrap();
      toast.success(value ? "Sync turned on" : "Sync turned off");
    } catch {
      toast.error("Failed to update sync");
    }
  };

  return (
    <div className="flex items-center justify-between">
      <Label htmlFor="syncEnabled" className="flex flex-col gap-1">
        <span>Sync</span>
        <span className="font-normal text-muted-foreground text-xs">
          {enabled
            ? "Contacts, calls and messages sync with this CRM"
            : "Nothing syncs to or from this CRM until you turn this back on"}
        </span>
      </Label>
      <Switch id="syncEnabled" checked={enabled} disabled={isLoading} onCheckedChange={toggleSync} />
    </div>
  );
}
